module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "cipf"
  }, [_vm._v("Copyright © 2006 by Priscilla Royal")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("First Edition 2006")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Catalog Card Number: 2005928746")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("ISBN-10 Print: 1-59058-214-4")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("ISBN-13 eBook: 978-1-61595-182-6")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in, or introduced into a retrieval system, or transmitted in any form, or by any means (electronic, mechanical, photocopying, recording, or otherwise) without the prior written permission of both the copyright owner and the publisher of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Poisoned Pen Press")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("6962 E. First Ave., Ste. 103")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Scottsdale, AZ 85251")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "http://www.poisonedpenpress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.poisonedpenpress.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_c('a', {
    staticClass: "calibre2",
    attrs: {
      "href": "mailto:info@poisonedpenpress.com"
    }
  }, [_vm._v("info@poisonedpenpress.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ceb2e12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ppp-sorrowend0003.vue
// module id = 66
// module chunks = 0